// extracted by mini-css-extract-plugin
module.exports = {"bd":"_5147","group":"_18816","title":"_19966","icon":"_10388","name":"_11777","arrow":"_16968","actions":"_6236","item":"_4376","list":"_10135","empty":"_18216"};